import { LOGIN_USR } from "../environment/environment";
import { LOGIN_PSSW } from "../environment/environment";
import { Login } from "../model/Login";

export const mockUser: Login = {
	username: `${LOGIN_USR}`,
	password: `${LOGIN_PSSW}`,
};
